import { ICartProps } from '../../../../contexts/CartContext/CartContext.types';
import StoreLocatorApi from '../../../../components/forms/StoreLocator/StoreLocator.api';
import { IStoreLocation } from '../../../../components/forms/StoreLocator/StoreLocator.types';

export const useGetClosestStoreHook = (
    cart: ICartProps,
    onSuccess: (response: IStoreLocation[]) => void,
    onFailure: () => void,
    useDefault?: boolean
) => {
    const customerAddressSearch = `${cart.customerInfo.address.zipcode}`;
    StoreLocatorApi.SearchStores(customerAddressSearch, onSuccess, onFailure, useDefault);
};
